import { render, staticRenderFns } from "./AddOrEditRoomForm.vue?vue&type=template&id=2b3a557a"
import script from "./AddOrEditRoomForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditRoomForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditRoomForm.vue?vue&type=style&index=0&id=2b3a557a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports